export class GridUpdate {
  variationId: string;
  name: string;
  gridId: string;
  gridName : string;
  products: string;
  unit: string;
  quantityMin: number;
  quantityMax: number;
  fixedCost: number;
  minPrice: number;
  prices: number[];

  constructor(data?: Partial<GridUpdate>) {
    this.variationId = data?.variationId ?? '';
    this.name = data?.name ?? '';
    this.gridId = data?.gridId ?? '';
    this.gridName = data?.gridName ?? '';
    this.products = data?.products ?? '';
    this.unit = data?.unit ?? '';
    this.quantityMin = data?.quantityMin ?? 0;
    this.quantityMax = data?.quantityMax ?? 0;
    this.fixedCost = data?.fixedCost ?? 0;
    this.minPrice = data?.minPrice ?? 0;
    this.prices = data?.prices ?? [];
  }
}
